// extracted by mini-css-extract-plugin
export default {"wrapper":"ListPlaceholder_wrapper__92K5g","gradient":"ListPlaceholder_gradient__IA5rY"};